///ts:ref=PandaConsole
/// <reference path="../console/PandaConsole.ts"/> ///ts:ref:generated

class StatEvent {
	constructor(projectName:string, siteName:string, eventType:string = null) {
		this.addUniq('project', projectName, StatDataType.noType);
		this.addUniq('site', siteName, StatDataType.noType);
		if (eventType !== null) {
			this.setType(eventType);
		}
		this.addUniq('v', 2, StatDataType.noType);
	}

	private _unqs: {[uniqName:string]:StatUniq} = {};

	public setType(eventType:string) {
		this.addUniq('type', eventType, StatDataType.noType);
	}

	public addUniq(uniqName:string, value:string | number, type:string) {
		PandaConsole.here;
		this.checkUniqName(uniqName);
		if (!StatDataType.isTypeValid(type)) {
			PandaConsole.errorUncritical(new PandaError('Stat type is wrong ' + uniqName));
		}
		if (this.hasUniq(uniqName)) {
			PandaConsole.errorUncritical(new PandaError('Stat uniq name duplicate ' + uniqName));
		}
		this._unqs[uniqName] = new StatUniq(uniqName, value, type);
	}

	public hasUniq(uniqName:string):boolean {
		return !!this._unqs[uniqName];
	}

	public $getData():any {
		let obj:any = {};

		for (let key in this._unqs) {
			let uniq:StatUniq = this._unqs[key];
			if (uniq.type === StatDataType.noType) {
				obj[uniq.uniqName] = uniq.value;
			} else {
				obj[uniq.uniqName + '/' + uniq.type] = uniq.value;
			}
		}

		return obj;
	}

	private _uniqNameRegexp:RegExp = /[A-Z]/;
	private checkUniqName(uniqName:string):boolean {
		let valid:boolean = true;
		PandaConsole.here;
		if (uniqName.match(this._uniqNameRegexp)) {
			PandaConsole.errorUncritical(new PandaError('Stat uniqName contains UPPERCASE symbols ' + uniqName));
			valid = false;
		}
		if (uniqName.indexOf('/') >= 0) {
			PandaConsole.errorUncritical(new PandaError('Stat uniq name contains "/" ' + uniqName));
			valid = false;
		}
		return valid;
	}
}

class StatUniq {
	public constructor(uniqName:string, value:string|number, type:string) {
		this.uniqName = uniqName;
		this.value = value;
		this.type = type;
	}
	public uniqName:string;
	public value:string|number;
	public type:string;
}

class StatDataType {
	public static noType: string 		= 'noType';
	public static string: string 		= 's';
	public static money: string 		= 'm';
	public static date: string 			= 'date';

	public static projDict8: string 	= 'pd8';
	public static projDict16: string 	= 'pd16';
	public static projDict32: string 	= 'pd32';

	public static typeDict8: string 	= 'td8';
	public static typeDict16: string 	= 'td16';
	public static typeDict32: string 	= 'td32';

	public static sideDict8: string 	= 'sd8';
	public static sideDict16: string 	= 'sd16';
	public static sideDict32: string 	= 'sd32';

	public static typeGroupDict8: string 	= 'gd8';
	public static typeGroupDict16: string 	= 'gd16';
	public static typeGroupDict32: string 	= 'gd32';

	public static i8: string 			= 'i8';
	public static i16: string 			= 'i16';
	public static i32: string 			= 'i32';
	public static i64: string 			= 'i64';

	public static ui8: string 			= 'ui8';
	public static ui16: string 			= 'ui16';
	public static ui32: string 			= 'ui32';
	public static ui64: string			= 'ui64';

	private static _typeCache:{[type:string]:boolean};
	public static isTypeValid(typeName:string):boolean {
		if (!StatDataType._typeCache) {
			let cache: { [type: string]: boolean } = {};
			for (let key in StatDataType) {
				cache[(<any>StatDataType)[key]] = true;
			}
			this._typeCache = cache;
		}
		return !!this._typeCache[typeName];
	}
}